{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} σινομιλίες επιλέχθηκαν",
    "AGENT_SELECT_LABEL": "Επιλογή πράκτορα",
    "ASSIGN_CONFIRMATION_LABEL": "Είσαστε σίγουροι ότι θέλετε να αντιστοιχίσετε {conversationCount} {conversationLabel} στον",
    "UNASSIGN_CONFIRMATION_LABEL": "Είσαστε σίγουροι ότι θέλετε να αφαιρέσετε την αντιστοίχιση {conversationCount} {conversationLabel} στον;",
    "GO_BACK_LABEL": "Πίσω",
    "ASSIGN_LABEL": "Αντιστοίχιση",
    "YES": "Ναι",
    "SEARCH_INPUT_PLACEHOLDER": "Αναζήτηση",
    "ASSIGN_AGENT_TOOLTIP": "Ανάθεση σε πράκτορα",
    "ASSIGN_TEAM_TOOLTIP": "Ανάθεση ομάδας",
    "ASSIGN_SUCCESFUL": "Οι σινομιλίες αντιστοιχήθηκαν επιτυχώς.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Οι σινομιλίες επιλύθηκαν επιτυχώς.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Επιλέχθηκαν μόνο οι σινομιλίες που φαίνονται στην σελίδα.",
    "AGENT_LIST_LOADING": "Φόρτωση πρακτόρων",
    "UPDATE": {
      "CHANGE_STATUS": "Αλλαγή κατάστασης",
      "SNOOZE_UNTIL": "Αναβολή",
      "UPDATE_SUCCESFUL": "Η κατάσταση συνομιλίας ενημερώθηκε με επιτυχία.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "Δεν βρέθηκαν πρότυπα για",
      "ASSIGN_SELECTED_LABELS": "Ανάθεση επιλεγμένων ετικετών",
      "ASSIGN_SUCCESFUL": "Επιτυχής ανάθεση ετικετών.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Επιλογή ομάδας",
      "NONE": "Κανένα",
      "NO_TEAMS_AVAILABLE": "Δεν έχουν προστεθεί ομάδες σε αυτόν τον λογαριασμό ακόμα.",
      "ASSIGN_SELECTED_TEAMS": "Ανάθεση επιλεγμένης ομάδας.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Συγχώνευση συνομιλιών",
      "TITLE": "Συγχώνευση Συνομιλιών",
      "DESCRIPTION": "Επιλέξτε μια συνομιλία-στόχο. Όλες οι υπόλοιπες επιλεγμένες συνομιλίες θα συγχωνευθούν σε αυτήν — τα μηνύματά τους θα μεταφερθούν στη συνομιλία-στόχο και οι αρχικές συνομιλίες θα διαγραφούν.",
      "TARGET_LABEL": "Συνομιλία-στόχος (θα διατηρηθεί)",
      "SOURCES_LABEL": "Αρχικές συνομιλίες (θα διαγραφούν)",
      "SELECT_TARGET": "Επιλέξτε μια συνομιλία ως στόχο συγχώνευσης",
      "WARNING": "Προειδοποίηση: Αυτή η ενέργεια δεν μπορεί να αναιρεθεί. Τα μηνύματα από όλες τις αρχικές συνομιλίες θα μεταφερθούν στη συνομιλία-στόχο και οι αρχικές συνομιλίες θα διαγραφούν οριστικά.",
      "SUBMIT": "Συγχώνευση Συνομιλιών",
      "CANCEL": "Άκυρο",
      "SUCCESS_MESSAGE": "Οι συνομιλίες συγχωνεύθηκαν επιτυχώς",
      "ERROR_MESSAGE": "Δεν ήταν δυνατή η συγχώνευση των συνομιλιών. Παρακαλώ προσπαθήστε ξανά.",
      "CONFIRM": {
        "TITLE": "Επιβεβαίωση Συγχώνευσης",
        "DESCRIPTION": "Είστε σίγουροι ότι θέλετε να συγχωνεύσετε {sourceCount} συνομιλίες στο #{targetId}; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
        "YES": "Ναι, Συγχώνευση",
        "CANCEL": "Άκυρο"
      }
    }
  }
}
